// import { getURLParams } from './Utilities.js'
import Vue from 'vue'

import VueFire from 'vuefire'
import * as firebase from 'firebase'
import router from './router'
import { store } from './store'
import Vuetify from 'vuetify'
import 'vuetify/dist/vuetify.min.css'
import { firebaseConfig } from './store/fbdata'
import tabsRow from './components/shared/TabsRow.vue'
import splitPane from 'vue-splitpane'
import wrapperComponent from '@/components/shared/Wrapper'
// 7/23/18, old syntax //import App from './App'
const App = () => import('./App')
const AlertCmp = () => import('./components/shared/Alert.vue')

// console.log('>getURLParams', getURLParams)

Vue.use(
  Vuetify
  // , {
  //   theme: {
  //     primary: '#ee44aa',
  //     secondary: '#424242',
  //     accent: '#82B1FF',
  //     error: '#FF5252',
  //     info: '#2196F3',
  //     success: '#4CAF50',
  //     warning: '#FFC107'
  //   }
  // }
)
Vue.use(VueFire)

Vue.config.productionTip = false

// Vue.component('utils', Utilities)
Vue.component('app-alert', AlertCmp)
Vue.component('tabsRow', tabsRow)
Vue.component('splitPane', splitPane)

Vue.component('wrapper-iframe', wrapperComponent)
/* eslint-disable no-new */
// eslint-disable

router.afterEach((to, from) => {
  Vue.nextTick(() => {
    // sometimes a title isn't ready because path doesn't exist, i need a default path to fix this error
    try {
      document.title = to.meta.title(to)
    } catch (error) {
      document.title = 'Agendakit'
    }
  })
})

new Vue({
  el: '#app',
  router,
  store,
  render: h => h(App),
  template: '<App/>',
  components: { App },
  // methods: {
  //   // https://forum.vuejs.org/t/create-and-import-my-own-js-to-vue-project/30770/2
  //   getURLParams: getURLParams
  // },
  created() {
    this.$store.dispatch('setUserAuthInProgress', true)
    firebase.initializeApp(firebaseConfig)
    // does this work? frik! firebase.auth().setPersistence(firebase.auth.Auth.Persistence.LOCAL)
    firebase.auth().onAuthStateChanged(user => {
      if (user) {
        this.$store.dispatch('autoSignIn', user)
      }
      this.$store.dispatch('setUserAuthInProgress', false)
    })
    // BYPASS_AUTH
    this.$store.dispatch('signUserIn', {
      email: 'BYPASS_AUTH@TEMPORARY.COM',
      password: 'G00dness!'
    })
  }
})
